import { clearAuthClientState } from "utils/cookie";
import { isPublicAuthPath } from "utils/environment";

export const unauthorizedMiddleware = (store) => (next) => (action) => {
  // We check that the action contains the error property and the error value is equal to "Unauthorized"
  if (
    action.result &&
    (action.result.error === "Unauthorized" ||
      action.result.error === 401 ||
      action.result === 401)
  ) {
    const pathname = window.location.pathname || "";
    const isPublic = isPublicAuthPath(pathname);

    if (!isPublic) {
      try {
        clearAuthClientState();
      } catch {
        /* ignore */
      }
      // Do not location.replace here — SessionExpiredModal handles the hop.
      // A hard redirect while the cookie still existed sent login ↔ app in a loop.
    }
  }

  return next(action);
};
